package ru.playa.sce.dto

class MapData(val center: Point, val area: Area)
